import { NgModule } from '@angular/core';
import { BusinessPartnersComponent } from './business-partners.component';
import { ProspectsPopupComponent } from './prospects-popup/prospects-popup.component';
import { SharedModule } from '../../shared/shared.module';
import { SyncfusionModule } from '../../shared/syncfusion.module';
import { ProspectsDetailsTabComponent } from './prospects-popup/prospects-details-tab/prospects-details-tab.component';
import { BusinessPartnersRoutingModule } from './business-partners.routing.module';
import { EquipmentBpComponent } from './prospects-popup/equipment-bp/equipment-bp.component';


@NgModule({
  declarations: [
    BusinessPartnersComponent
  ],
  imports: [
    SharedModule,
    SyncfusionModule,
    ProspectsPopupComponent,
    ProspectsDetailsTabComponent,
    BusinessPartnersRoutingModule,
    EquipmentBpComponent
  ],
  exports: [
    BusinessPartnersComponent,
    ProspectsPopupComponent
  ],
  providers: []
})
export class BusinessPartnerModule { }
